<template>
    <div class="legend-element">
        <ds-popover :is-open="legendHovered">
            <template #reference>
                <div class="legend-label" @mouseover="legendHovered=true" @mouseleave="legendHovered=false">
                    <div class="shaded-box" :style="`background-color: ${itemColor}`" />

                    <div class="legend-text">
                        {{ label }}
                    </div>
                </div>
            </template>

            <template #default>
                <div class="popover-content">
                    {{ hoverLabel }}
                </div>
            </template>
        </ds-popover>
    </div>
</template>

<script>
export default {
    props: {
        itemType: String,
        itemCount: Number,
        itemTotal: Number,
        label: String,
        itemColor: String,
        hoverContentLabel: String,
        hoverLabelOverride: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            legendHovered: false,
        };
    },
    computed: {
        getItemPercentage() {
            return Math.round((this.itemCount / this.itemTotal) * 100);
        },
        hoverLabel() {
            if (this.hoverLabelOverride) {
                return `${this.getItemPercentage }% (${ this.hoverLabelOverride })`;
            }

            return `${this.getItemPercentage }% (${ this.itemCount } ${ this.hoverContentLabel })`;
        },
    },
};
</script>

<style lang="scss" scoped>
.legend-label {
    display: flex;
    margin-bottom: $spacing-100;
}
.legend-text {
    flex-grow: 1;
    font-size: $font-size-md;
    color: $color-ink-900;
}
.shaded-box {
    height: 16px;
    width: 16px;
    margin-right: $spacing-100;
}
</style>
